import {
  Card,
  CardMedia,
  Grid,
  Modal,
  SvgIcon,
  Typography,
} from "@mui/material";
import { useApp } from "../hooks/useApp";
import { ListItem, List } from "@mui/material";
import { ListItemText } from "@mui/material";
import { Divider } from "@mui/material";
import React, { useState, useEffect, useMemo } from "react";
import Tagger from "./Tagger";
import Gobutton from "./Gobutton";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import LaptopMacIcon from "@mui/icons-material/LaptopMac";
import FactoryIcon from "@mui/icons-material/Factory";
import "./Factorymap.css";
import Factorymodal from "./Factorymodal";
import InfoIcon from "@mui/icons-material/Info";
import Videoplayer from "./Videoplayer";
import { useSegment } from "../hooks/useSegment";
import Megafactory from "../pages/composable/Megafactory";
import { useTheme } from "@mui/material/styles";
import LinkIcon from "@mui/icons-material/Link";
import { useAuth } from "../hooks/useAuth";
import { CustomButton } from "./Common/CustomButton";
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import WebAssetIcon from '@mui/icons-material/WebAsset';
import { ReactComponent as TulipLibrary } from "../svgs/tulipLibraryWhite.svg";

const style = {
  p: 0,
  width: "100%",
  borderRadius: 2,
  border: "1px solid",
  borderColor: "divider",
  backgroundColor: "#FFF",
};

function AssetPreviewMedia({ url }) {
  const mediaType = useMemo(() => {
    if (!url) return "image";
    const lower = url.toLowerCase();
    if (
      lower.includes(".mp4") || lower.includes(".webm") ||
      lower.includes(".mov") || lower.includes(".mkv")
    ) return "video";
    if (
      lower.includes("youtube.com") || lower.includes("youtu.be") ||
      lower.includes("wistia.com") || lower.includes("vimeo.com")
    ) return "embed";
    return "image";
  }, [url]);

  const embedUrl = useMemo(() => {
    if (mediaType !== "embed" || !url) return "";
    const match = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([a-zA-Z0-9_-]+)/);
    return match ? `https://www.youtube.com/embed/${match[1]}?autoplay=1&mute=1&loop=1&playlist=${match[1]}` : url;
  }, [url, mediaType]);

  const mediaStyle = {
    boxShadow: "none",
    maxWidth: "100%",
    maxHeight: "80vh",
    objectFit: "cover",
    objectPosition: "center",
  };

  if (!url) return null;

  if (mediaType === "embed") {
    return (
      <div style={{ position: "relative", width: "100%", paddingBottom: "56.25%" }}>
        <iframe
          src={embedUrl}
          title="Preview Video"
          allow="encrypted-media"
          allowFullScreen
          style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", border: "none" }}
        />
      </div>
    );
  }

  if (mediaType === "video") {
    return (
      <video
        src={url}
        autoPlay
        loop
        muted
        playsInline
        style={mediaStyle}
      />
    );
  }

  return (
    <CardMedia
      component="img"
      image={url}
      style={mediaStyle}
    />
  );
}

export default function Assetmodal() {
  const {
    selectedAsset = null,
    setSelectedAsset,
    activeFactory,
    activeVideo,
    activeMegaFactory,
  } = useApp();
  const [factoryLink, setFactoryLink] = useState("");
  const { user } = useAuth();
  const { trackEvent } = useSegment();
  const theme = useTheme();
  useEffect(() => {
    if (selectedAsset) {
      trackEvent("asset opened");
      if (user) {
        if (
          selectedAsset.Type === "factory" ||
          selectedAsset.Type === "megafactory"
        ) {
          setFactoryLink(`/factory/${user.uid}/${selectedAsset.id}`);
        } else {
          setFactoryLink(`/asset/${user.uid}/${selectedAsset.id}`);
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <Modal
      open={selectedAsset !== null && selectedAsset !== undefined}
      onClose={() => setSelectedAsset(null)}
      disableAutoFocus
      closeAfterTransition
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
      }}
    >
      <Grid
        container
        xs={11}
        md={10}
        justifyContent="center"
        alignItems={"top"}
        overflow={"hidden"}
        borderRadius={"8px 0px 0px 0px"}
        className="flex-nowrap "
      >
        {activeFactory && <Factorymodal />}
        {activeMegaFactory && <Megafactory />}
        <Grid item>
          <svg
            width={35}
            id="topper-notch"
            viewBox="0 0 42 152"
            overflow={"hidden"}
          >
            <path
              d="M41 0H40H1H0V96.5C0 101.6 2 106.3 5.6 109.9L35 139.4C38.2 142.6 40 146.9 40 151.4H41H42V0H41Z"
              fill={theme.palette.background.default}
            ></path>
            <path
              d="M35.7 138.7L6.3 109.3C2.9 105.9 1 101.3 1 96.6V0H0V96.5C0 101.6 2 106.3 5.6 109.9L35 139.4C38.2 142.6 40 146.9 40 151.4H41C41 146.7 39.1 142.1 35.7 138.7Z"
              fill={theme.palette.background.default}
            ></path>
          </svg>
        </Grid>
        <Grid
          item
          xs
          sx={{ backgroundColor: "background.default" }}
          marginY={"auto"}
          borderRadius={"0px 8px 8px 8px"}
          className="p-4 md:p-8"
        >
          <Grid container gap={2}>
            <Grid container className="screen-height overflow-y-auto" gap={2}>
              <Grid
                item
                xs={12}
                display={"flex"}
                justifyContent={"space-between"}
              >
                <Typography color={"customColors.default"} variant="h5">
                  {selectedAsset.Title}
                </Typography>
                {user && (
                  <a
                    href={factoryLink}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <CustomButton
                      variant="contained"
                      color="secondary"
                      size="small"
                      endIcon={<LinkIcon />}
                    >
                      Link
                    </CustomButton>
                  </a>
                )}
              </Grid>
              <Grid item xs={12} sm={6} alignItems={"center"}>
                <Card
                  sx={{ boxShadow: "none", backgroundColor: "transparent" }}
                >
                  <AssetPreviewMedia url={selectedAsset.mediaUrl || selectedAsset.img || selectedAsset.Image} />
                </Card>
              </Grid>
              {activeVideo && <Videoplayer />}
              <Grid item xs className="!mt-2">
                <Typography variant="h6" color={"customColors.default"}>
                  Key Features
                </Typography>
                {selectedAsset.Features && selectedAsset.Features[0] !== "" && (
                  <List aria-label="mailbox folders" sx={style}>
                    {selectedAsset.Features.map((feature, index) => (
                      <React.Fragment key={index}>
                        <ListItem color={"customColors.default"}>
                          <ListItemText
                            sx={{ color: "customColors.defaultLight" }}
                            primary={feature}
                          />
                        </ListItem>
                        {index < selectedAsset.Features.length - 1 && (
                          <Divider component="li" />
                        )}
                      </React.Fragment>
                    ))}
                  </List>
                )}
              </Grid>
              <Grid item xs={12} md={6} className="!mt-3">
                <Tagger />
              </Grid>
            </Grid>
            <Grid
              container
              justifyContent={"right"}
              alignItems={"bottom"}
              gap={2}
            >
              {selectedAsset.tulipLibrary && (
                <Gobutton
                  text={"Open in Tulip Library"}
                  startIcon={
                    <SvgIcon
                      className="tulipLibrary"
                      inheritViewBox
                      sx={{
                        height: "18px",
                        width: "auto",
                        color: "customColors.white",
                      }}
                      component={TulipLibrary}
                    />
                  }
                  url={{ type: "beacon", url: selectedAsset.tulipLibrary }}
                />
              )}
              {selectedAsset.appUrl && (
                <Gobutton
                  text={"Open the App"}
                  startIcon={<ExitToAppIcon />}
                  url={{ type: "beacon", url: selectedAsset.appUrl }}
                />
              )}
              {selectedAsset.htmlUrl && (
                <Gobutton
                  text={"Preview App"}
                  startIcon={<WebAssetIcon />}
                  url={{ type: "mockpc", url: selectedAsset.htmlUrl }}
                />
              )}
              {selectedAsset.pdf && (
                <Gobutton
                  text={"Open Demo Guide"}
                  startIcon={<PictureAsPdfIcon />}
                  url={{ type: "beacon", url: selectedAsset.pdf }}
                />
              )}
              {selectedAsset.editorUrl && (
                <Gobutton
                  text={"Open the Editor"}
                  startIcon={<LaptopMacIcon />}
                  url={{ type: "beacon", url: selectedAsset.editorUrl }}
                />
              )}
              {selectedAsset.contentUrl && (
                <Gobutton
                  text={"More info"}
                  startIcon={<InfoIcon />}
                  url={{ type: "content", url: selectedAsset.contentUrl }}
                />
              )}
              {selectedAsset.video && (
                <Gobutton
                  text={"Play the Video"}
                  startIcon={<InfoIcon />}
                  url={{ type: "video", url: selectedAsset.video }}
                />
              )}

              {selectedAsset.Type === "factory" && (
                  <Gobutton
                    text={"Explore the Factory"}
                    startIcon={<FactoryIcon />}
                    url={"factory"}
                  />
              )}
              {selectedAsset.Type === "megafactory" && (
                  <Gobutton
                    text={"Explore the Factory"}
                    startIcon={<FactoryIcon />}
                    url={"megafactory"}
                  />
              )}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Modal>
  );
}
